<div class="min-h-0 flex-1 overflow-x-hidden overflow-y-auto [-webkit-overflow-scrolling:touch]">
	<app-top-search-filter-items
		[filters]="filters"
		[variant]="'vertical'"
		[showAdvancedHeader]="false"
	></app-top-search-filter-items>
</div>
